import { Component, OnInit } from '@angular/core';
import { User } from '../../classes/user';
import { AuthService } from '../../services/auth';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user = new User();
  signInFailed = false;

  constructor(private authService: AuthService,
              private router: Router) {}

  ngOnInit(): void {
    if (this.authService.isUserSignedIn()) {
        window.location.href = 'inspection';
    }
    this.authService.signInFailed
        .subscribe({
          next: () => {
            this.signInFailed = true;
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
          }
        });
  }

  onSubmit() {
    this.authService.signIn(this.user);
  }
}
